import { createSelector } from '@reduxjs/toolkit';

import {
  PAYMENT_REGISTRATION_FEATURE_KEY,
  PaymentRegistrationState,
} from './paymentRegistration.slice';

export const getRegistrationState = (
  rootState: any,
): PaymentRegistrationState => rootState[PAYMENT_REGISTRATION_FEATURE_KEY];

export const selectRegistrationLoading = createSelector(
  getRegistrationState,
  (s) => s.isRegistrationLoading,
);

export const selectRegistrationResultAction = createSelector(
  getRegistrationState,
  (s) => s.resultAction,
);

export const selectRegistrationError = createSelector(
  getRegistrationState,
  (s) => s.error,
);

export const selectRegistrationResponseSuccess = createSelector(
  getRegistrationState,
  (s) => s.isRegistrationSuccess,
);

export const selectRegistrationResponseFailed = createSelector(
  getRegistrationState,
  (s) => s.isRegistrationFailed,
);
